if (!customElements.get('ths-manual-gallery')) {
  customElements.define('ths-manual-gallery', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info');
      this.onClick = event => {
        const thumb = event.target.closest('[data-gallery-index]');
        if (thumb) this.select(Number(thumb.dataset.galleryIndex));
        if (event.target.closest('[data-gallery-zoom]')) {
          const source = this.querySelector('[data-gallery-main]');
          const zoom = this.querySelector('[data-gallery-full]');
          zoom.src = source.dataset.full;
          zoom.alt = source.alt;
          this.querySelector('dialog').showModal();
        }
        if (event.target.closest('[data-gallery-close]') || event.target === this.querySelector('dialog')) {
          this.querySelector('dialog').close();
        }
      };
      this.onKey = event => {
        if (!event.target.closest('[data-gallery-index]')) return;
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const current = Number(this.querySelector('[data-gallery-index][aria-current="true"]').dataset.galleryIndex);
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? 2 : (current + (event.key === 'ArrowRight' ? 1 : 2)) % 3;
        this.select(index);
        this.querySelector(`[data-gallery-index="${index}"]`).focus();
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKey);
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data.sectionId !== this.root.dataset.section) return;
        const next = data.html.querySelector('ths-manual-gallery');
        if (!next || next.dataset.language === this.dataset.language) return;
        this.querySelector('dialog')?.close();
        this.dataset.language = next.dataset.language;
        this.innerHTML = next.innerHTML;
      });
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKey);
      this.unsubscribe?.();
    }
    select(index) {
      const button = this.querySelector(`[data-gallery-index="${index}"]`);
      const source = button.querySelector('img');
      const main = this.querySelector('[data-gallery-main]');
      main.src = button.dataset.src;
      main.srcset = button.dataset.srcset;
      main.alt = source.alt;
      main.dataset.full = button.dataset.full;
      this.querySelectorAll('[data-gallery-index]').forEach(item => item.setAttribute('aria-current', String(item === button)));
      this.querySelector('[data-gallery-zoom]').setAttribute('aria-label', button.dataset.zoomLabel);
    }
  });
}
